<template>
    <div class="top-bar">
        <div class="group-select-container" v-if="storeReady && !apiCall">
            <MultiSelect :allow-empty="false" :close-on-select="true"
                         :deselectLabel="$t('multiselect.deselectLabel')"
                         :options="groups"
                         :placeholder="$t('multiselect.placeholder')"
                         :searchable="false"
                         :selectLabel="$t('multiselect.selectLabel')"
                         :selectedLabel="$t('multiselect.selectedLabel')"
                         :show-labels="false"
                         @input="handleInput"
                         class="group-select"
                         label="name"
                         track-by="id"
                         v-model="selectValue"

            ></MultiSelect>
            <LanguageSwitcher></LanguageSwitcher>
        </div>
        <div class="group-select-container" v-if="storeReady && apiCall">
            {{$t('messages.genericWait')}}
        </div>
        <div class="logo" id="logo">
            <router-link :to="{name: 'dashboard-main'}"><img :src="logoPath"></router-link>
        </div>
    </div>

</template>

<script>
import MultiSelect from 'vue-multiselect';
import LanguageSwitcher from '@/components/helpers/LanguageSwitcher.vue';
import {RepositoryFactory} from '@/api/RepositoryFactory';

const GroupRepository = RepositoryFactory.get('groups');
const SalonsRepository = RepositoryFactory.get('salons');
const DevicesRepository = RepositoryFactory.get('devices');

export default {

  name: 'TopBar',
  data() {
    return {
      selectValue: {},
      groups: [],
      logoPath: '/logo.png',
    };
  },
  watch: {
    storeReady(newValue) {
      if (newValue) {
        this.groups = this.$store.getters.groups;
        this.selectValue = this.$store.getters.selectedGroup;
        this.logoPath = this.$store.getters.logo;
      }
    },
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    MultiSelect,
    LanguageSwitcher,
  },
  async mounted() {

  },
  computed: {
    apiCall() {
      return this.$store.getters.apiCall;
    },
    storeReady() {
      return this.$store.getters.loaded;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    config() {
      return this.$store.getters.backendConfig;
    },
  },
  methods: {
    async handleInput() {
      await this.$store.dispatch('setSelectedGroup', this.selectValue);
      localStorage.setItem('group', JSON.stringify(this.selectValue));
      const {token} = this.$store.getters;
      await this.$store.dispatch('setSelectedGroup', this.selectValue);
      const salons = await SalonsRepository.getShopsGroup(token, this.$store.getters.selectedGroup.id);
      await this.$store.dispatch('setSalons', salons);
      if (this.$store.getters.role === 'ADMINISTRATOR' || this.$store.getters.role === 'OPTIGUARD') {
        const devices = await DevicesRepository.getDevices(token, this.$store.getters.selectedGroup.id);
        await this.$store.dispatch('setDevices', devices);
      }
    },
  },

};
</script>

<style scoped lang="scss">
    [v-cloak] {
        display: none;
    }

    .top-bar {
        display: flex;
        background: white;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        justify-content: space-between;
        align-items: center;
        padding: 18px 53px;
        padding-left: 6px;
        width: 100%;
        position: fixed;
        z-index: 200;
        top: 0;
        left: 0;
        min-height: 76px;
        box-sizing: border-box;

        .logo {
            justify-self: flex-end;
            margin-left: auto;
            margin-right: 3%;
            max-width: 201px;
            max-height: 34px;
            object-fit: cover;
            @include media('<500px') {
                margin: 15px 0;
            }

            img {
                width: 100%;
                height: 100%;
                max-height: 34px;
                object-fit: cover;
            }
        }

        @include media('<500px') {
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
        }
    }

    .group-select-container::v-deep {
        width: 310px;
        display: flex;
        margin-left: 23px;

        .multiselect__content-wrapper {
            ul.multiselect__content {
                max-width: 100% !important;
                overflow-x: hidden !important;

                li.multiselect__element {
                    display: block;
                    max-width: 100%;

                    .multiselect__option {
                        span {
                            max-width: 100%;
                            white-space: normal;
                        }
                    }
                }
            }
        }
    }

    .multiselect__tags {
        border: none;

        .multiselect__placeholder, .multiselect__single {
            // color: $baseTextColor;
            font-size: rem(18px);
            text-transform: uppercase;
            font-weight: 900;
        }
    }

</style>
